import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { QueueItem, PlayerService } from '../player/player.service';

@Component({
  selector: 'queue-item',
  templateUrl: './queue-item.component.html',
  styleUrls: ['./queue-item.component.scss']
})
export class QueueItemComponent implements OnInit {

  constructor(
    private player : PlayerService
  ) { 

  }

  ngOnInit() {
  }

  get topLevel() {
    return this.item.parent == null;
  }

  get isActive() {
    if (!this.activeItem)
      return false;
    
    if (this.activeItem.id == this.item.id)
      return true;
    
    let isActive = false;
    let traversedItem = this.activeItem;
    while (traversedItem) {
      if (traversedItem.id == this.item.id) {
        isActive = true;
      }

      traversedItem = traversedItem.parent;
    }

    return isActive;
  } 

  @Input()
  item : QueueItem;

  @Input()
  activeItem : QueueItem;

  play() {
    this.player.playQueueItem(this.item);
  }

  remove() {
    this.player.removeQueueItem(this.item);
  }
}
